import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { removeChargingConnector } from '../../api/charging-connector.ts';
import { RemoveChargingConnectorRequest } from '../../api/requests/charging-connector-request.ts';

export default function useRemoveChargingConnector(): UseMutationResult<
  Awaited<ReturnType<typeof removeChargingConnector>>,
  Error,
  RemoveChargingConnectorRequest
> {
  return useMutation({
    mutationFn: removeChargingConnector,
  });
}
